import { useAuthToken, useOnMount, useUpdateSonarObjectReference } from '@hooks';
export const AdminReferenceDebugger = () => {
    const { isAdmin } = useAuthToken();
    const sonarObjectReference = useUpdateSonarObjectReference();
    useOnMount(() => {
        if (isAdmin) {
            window.sonar.sonarObjectReference = sonarObjectReference;
        }
    });
    return null;
};
